import { Layout } from "@zickko/client";
import { EmailSidebar } from "./EmailSidebar";
import { Outlet } from "react-router-dom";
// TODO:SCSS const logo = require("../assets/react.svg");

export const EmailPortalLayout = () => {
  //

  return (
    <Layout name="email-portal layout-sidebar">
      <EmailSidebar />
      <Outlet />
    </Layout>
  );
};
